import React from 'react';
import { IconButton } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

import { Popup, PopupProps } from 'components';

type PopupActionsCellProps = PopupProps;

export const PopupActionsCell = (props: PopupActionsCellProps) => {
  return (
    <Popup {...props}>
      <IconButton color="primary" size="small">
        <MoreHoriz />
      </IconButton>
    </Popup>
  );
};
